export const allContentLicenses = ["FREE", "PREMIUM"] as const;

export type ContentLicense = (typeof allContentLicenses)[number];
